import { connectWithStore } from '../../../jsCore/utils/connectWithStore'
import { isMenuOpen } from '../../../jsCore/store/menu/menu.selectors'
import { MenuButtonContainer } from './menuButton.container'
import { toggleMenu } from '../../../jsCore/store/menu/menu.actions'

const mapStateTpProps = state => ({
  isMenuOpen: isMenuOpen(state),
})

const mapDispatchToProps = {
  toggleMenu: toggleMenu,
}

export const MenuButtonWithStoreComponent = connectWithStore(
  MenuButtonContainer,
  mapStateTpProps,
  mapDispatchToProps
)



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/header/menu/menuButtonWithStore.container.js